import { isExpEditor } from '../lib/lib'

class loginButton {
  constructor(element) {
    if (!element) {
      return false
    }

    if (isExpEditor()) {
      return false
    }

    this.link = jQuery(element)

    jQuery(this.link).on('click', () => {
      jQuery(document).trigger('login-clicked', jQuery(this.link))
    })
  }
}

export default loginButton
